import { X, Home, Heart, Utensils, Dumbbell, User, Warehouse, ShoppingBag, Package, ScrollText, BookOpen, Trophy, LogOut, PlusCircle, Medal, IdCard, Wrench, MessageSquare, Sparkles, Search, Gem, Flag, Mountain } from "lucide-react";

export const MENU_ITEMS = [
  { id: "game-home", label: "Game Home", icon: Home },
  { id: "play", label: "Current Horse / Training", icon: Dumbbell },
  { id: "forum", label: "Player Forum", icon: MessageSquare },
  { id: "leaderboard", label: "Leaderboard", icon: Medal },
  { id: "discipline-comp", label: "Discipline Competitions", icon: Flag },
  { id: "collectors", label: "Collectors Book", icon: Gem },
  { id: "myprofile", label: "My Player Profile", icon: IdCard },
  { id: "find-players", label: "Find Players", icon: Search },
  { id: "friends", label: "Friends", icon: Search },
  { id: "barns", label: "Training Barns", icon: Warehouse },
  { id: "hma", label: "My HMA", icon: Mountain },
  { id: "care", label: "Daily Care", icon: Heart },
  { id: "feedroom", label: "Feed Room", icon: Utensils },
  { id: "inventory", label: "Inventory", icon: Package },
  { id: "journal", label: "Journal", icon: ScrollText },
  { id: "stable", label: "My Stable", icon: Warehouse },
  { id: "upgrades", label: "Stable Upgrades", icon: Sparkles },
  { id: "shop", label: "Tack & Barn Shop", icon: ShoppingBag },
  { id: "premium", label: "Premium Shop", icon: Gem },
  { id: "alumni", label: "Alumni Book", icon: BookOpen },
  { id: "achievements", label: "Achievements", icon: Trophy },
];

export const GameNav = ({ open, onClose, view, onNavigate, onExit, hasHorse, canNew, alumniUnread, isAdmin, order }) => {
  const rank = (id) => { const i = order ? order.indexOf(id) : -1; return i === -1 ? 999 : i; };
  const items = [...MENU_ITEMS].sort((a, b) => rank(a.id) - rank(b.id));
  return (
  <div className={`fixed inset-0 z-[80] ${open ? "" : "pointer-events-none"}`} data-testid="game-drawer">
    <div className={`absolute inset-0 bg-black/50 transition-opacity ${open ? "opacity-100" : "opacity-0"}`} onClick={onClose} />
    <div className={`absolute left-0 top-0 h-full w-72 max-w-[80%] bg-primary text-primary-foreground shadow-2xl transition-transform duration-300 ${open ? "translate-x-0" : "-translate-x-full"}`}>
      <div className="flex items-center justify-between border-b border-white/15 px-4 py-4">
        <span className="font-display text-lg font-bold">Game Menu</span>
        <button data-testid="game-drawer-close" onClick={onClose} className="rounded-full p-1 hover:bg-white/10"><X size={20} /></button>
      </div>
      <nav className="flex flex-col gap-1 overflow-y-auto p-3" style={{ maxHeight: "calc(100% - 130px)" }}>
        {canNew && (
          <button data-testid="nav-newgame" onClick={() => { onNavigate("newgame"); onClose(); }}
            className="mb-1 flex items-center gap-3 rounded-xl bg-secondary px-3 py-2.5 text-left text-sm font-bold text-white transition-colors hover:bg-secondary/90">
            <PlusCircle size={17} /> Start New Makeover
          </button>
        )}
        {items.map(({ id, label, icon: Icon }) => {
          const disabled = !hasHorse && ["play", "care", "journal"].includes(id);
          return (
            <button key={id} data-testid={`nav-${id}`} disabled={disabled}
              onClick={() => { onNavigate(id); onClose(); }}
              className={`flex items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm font-semibold transition-colors ${view === id ? "bg-secondary text-white" : "hover:bg-white/10"} ${disabled ? "opacity-40" : ""}`}>
              <Icon size={17} /> {label}
              {id === "alumni" && alumniUnread > 0 && (
                <span data-testid="alumni-nav-badge" className="ml-auto grid h-5 min-w-5 place-items-center rounded-full bg-secondary px-1.5 text-[10px] font-bold text-white">{alumniUnread}</span>
              )}
            </button>
          );
        })}
        {isAdmin && (
          <button data-testid="nav-admin" onClick={() => { onNavigate("admin"); onClose(); }}
            className={`mt-1 flex items-center gap-3 rounded-xl border border-amber-300/40 bg-amber-500/15 px-3 py-2.5 text-left text-sm font-bold transition-colors ${view === "admin" ? "bg-amber-500 text-white" : "text-amber-100 hover:bg-amber-500/25"}`}>
            <Wrench size={17} /> Game Management
          </button>
        )}
      </nav>
      <button data-testid="nav-exit" onClick={onExit}
        className="absolute bottom-0 left-0 flex w-full items-center gap-3 border-t border-white/15 px-4 py-4 text-sm font-semibold hover:bg-white/10">
        <LogOut size={17} /> Exit Game
      </button>
    </div>
  </div>
  );
};
